import { applyAuth0Theme } from "@/utils/theme";

import PhoneIdentifierEnrollmentForm from "./components/PhoneEnrollmentForm";
import { usePhoneIdentifierEnrollmentManager } from "./hooks/usePhoneIdentifierEnrollmentManager";
import { AuthLayout } from "@/components/auth/AuthLayout";

function PhoneIdentifierEnrollmentScreen() {
    // Extracting attributes from hook made out of PhoneIdentifierEnrollment instance of Auth0 React ACUL SDK
    const { phoneIdentifierEnrollment, texts, locales } =
        usePhoneIdentifierEnrollmentManager();

    applyAuth0Theme(phoneIdentifierEnrollment);
    return (
        <AuthLayout title={texts?.pageTitle || locales.pageTitle}>

            <PhoneIdentifierEnrollmentForm />
            </AuthLayout>
    );
}

export default PhoneIdentifierEnrollmentScreen;
